const model = {
    currencyDetails: null,
    loading: false,
    error: null,
};

export default model;